import React from 'react'
import { Table } from 'react-bootstrap'

const TableHeader = ({
  tableName,
  isOrganizationTable,
}: {
  tableName: string
  isOrganizationTable: boolean
}) => {
  const headerTitles = [
    'id',
    'name',
    'logo',
    ...(isOrganizationTable ? ['status'] : []),
    'link',
  ]
  return (
    <>
      {headerTitles.map((title) => (
        <th key={title}>
          {tableName} {title}
        </th>
      ))}
    </>
  )
}

interface Data {
  id: string //
  name: string
  visible_logo_url: string
  badge_logo_url: string
  organization_id: string
  active?: boolean
}

const TableBody = ({
  data,
  link,
  parentData,
  showStatus,
}: {
  data: Data
  link: string
  parentData?: { active?: boolean }
  showStatus?: boolean
}) => {
  return (
    <tr key={data.id}>
      <td>{data.id}</td>
      <td>{data.name}</td>
      <td>
        <img
          src={data.visible_logo_url || data.badge_logo_url}
          alt={data.visible_logo_url || data.badge_logo_url}
          style={{ maxWidth: '90px' }}
        />
      </td>
      {showStatus && (
        <td>
          <span
            className={`badge ${
              parentData?.active ? 'bg-success' : 'bg-danger'
            }`}
            style={{ fontSize: '0.75rem', padding: '0.5em 1em' }}
          >
            {parentData?.active ? 'Active' : 'Inactive'}
          </span>
        </td>
      )}
      <td style={{ maxWidth: '90px' }}>
        <a
          href={`${window.location.origin}/${link}`}
          target="_blank"
          rel="noreferrer"
        >
          {`${window.location.origin}/${link}`}
        </a>
      </td>
    </tr>
  )
}

const UserOrgTeamTable = ({
  tableName,
  tableBodyData,
  tableBodyDataKey,
  link,
}: {
  tableName: string
  tableBodyData: Record<string, Data>[]
  tableBodyDataKey: number | string
  link: string
}) => {
  const isOrganizationTable = tableName.toLowerCase().includes('organization')

  const sortedData = [...tableBodyData].sort((a, b) => {
    const aActive = a.active ? 1 : 0
    const bActive = b.active ? 1 : 0
    return bActive - aActive
  })

  return (
    <Table striped bordered hover size="sm" variant="dark">
      {tableBodyData.length > 0 ? (
        <>
          <thead>
            <tr>
              <TableHeader
                tableName={tableName}
                isOrganizationTable={isOrganizationTable}
              />
            </tr>
          </thead>
          <tbody>
            {sortedData?.map((data, index) => (
              <TableBody
                data={data[tableBodyDataKey]}
                parentData={data}
                showStatus={isOrganizationTable}
                key={`${data[tableBodyDataKey].id}-${index}`}
                link={
                  link === 'team'
                    ? `organizations/${data?.[tableBodyDataKey]?.organization_id}/teams/${data?.[tableBodyDataKey]?.id}`
                    : `organizations/${data?.[tableBodyDataKey]?.id}`
                }
              />
            ))}
          </tbody>
        </>
      ) : (
        <thead>
          <tr>
            <td>{`No ${tableName} Associated With This User`}</td>
          </tr>
        </thead>
      )}
    </Table>
  )
}

export default UserOrgTeamTable
